import { Typography } from 'components';
import { LoadingIcon } from 'lib/svgs/Icons';
import { useTranslations } from 'next-intl';
import { cn } from 'utils/cn';

const LoadingContent = () => {
  const t = useTranslations();

  return (
    <div className="flex gap-2">
      <div className="flex w-6 items-center justify-center">
        <LoadingIcon className={cn('absolute animate-spin rounded-full')} />
      </div>
      <Typography variant="light5" className="!mb-0 text-center text-tertiary-200 ">
        {t('content_generation.tiptap.processing')}
      </Typography>
    </div>
  );
};

export default LoadingContent;
